import { SERVICE_GROUP_ID } from '@/constants';
import { ServiceGroup } from '@/types/serviceGroup';
import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';

type Props = {
  serviceGroupId: ServiceGroup['id'];
};

export const ServiceEndingAndStartAnnouncement: React.FC<Props> = (props) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  return (
    <>
      {props.serviceGroupId === SERVICE_GROUP_ID.emba && (
        <Announcement>
          <Trans i18nKey="ui.subscription.toEmbaEndingAndStartAnnouncement"></Trans>
        </Announcement>
      )}
      {props.serviceGroupId === SERVICE_GROUP_ID.hodaiplus && (
        <Announcement>
          <Trans i18nKey="ui.subscription.toHodaiPlusEndingAndStartAnnouncement">
            <a
              href={`${baseUrl}/services/9`}
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </Trans>
        </Announcement>
      )}
    </>
  );
};

const Announcement = styled.div`
  color: red;
  font-size: 14px;
  border: 1px;
  margin-bottom: 20px;
`;
